/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 15:26 19.04.2023
 * @ Description: utiliser pour faire les appèle sur l'api
 */

// read config file
import data from '../config.json';
import GameAdmin from '../GameClass/gameAdmin';
import Sentence from '../GameClass/sentence';
import SentenceError from '../GameClass/sentenceError';
import dataOffLine from  '../ressources/data/sentence.json';


export default class api{

    static isOnline=data.online;


    
    /**
     * function de base pour toute les requet
     * @param {string} req requet
     * @param {function} callback callback function 
     */
    static #request(req,callback){
        let address=data.apiServer.adresse+req;
        const xhttp = new XMLHttpRequest();
        xhttp.onload = function() {
            callback(JSON.parse(this.response));
        }
        xhttp.open("GET", address, true);
        xhttp.setRequestHeader("token",data.apiServer.apiToken);
        xhttp.send();
    }

    /**
     * function de base pour toute les requet (post)
     * @param {string} req requet
     * @param {object} body body requet
     * @param {function} callback callback function 
     */
    static #requestPost(req,body,callback){
        let address=data.apiServer.adresse+req;
        const xhttp = new XMLHttpRequest();
        xhttp.onload = function() {
            callback(JSON.parse(this.response));
        }
        xhttp.open("POST", address, true);
        xhttp.setRequestHeader("token",data.apiServer.apiToken);
        xhttp.setRequestHeader('Content-type', 'application/json');

        let content=JSON.stringify(body);

        xhttp.send(content);
    }


    /**
     * Génère un liste d'objet sentence a partire du json de la requet api
     * @param {json} data 
     * @returns liste de sentences
     */
    static #genSentenceObject(data){
        let sentences=[];
        for (let index = 0; index < data.Sentences.length; index++) {
            const sen = data.Sentences[index];
            
            let errors=[];
            // get error
            for (let index = 0; index < data.Errors.length; index++) {
                const err = data.Errors[index];
                if(err.fkSentence==sen.idSentence){
                    errors.push(new SentenceError(err.errCorrection,err.errStartCharPos,err.errEndCharPos));
                }
            }
            let newSen=new Sentence(sen.idSentence,sen.senSentence,errors);
            sentences.push(newSen);
        }
        return sentences;
    }

    static getAllSentence(callback){
        if(this.isOnline){
            this.#request("/api/sentence/getAllSentence",(data)=>{
                callback(this.#genSentenceObject(data));
            })
        }
        else{
            callback(this.#AllSentence());
        }
    }


    static getRandomSentence(callback){
        if(this.isOnline){
            this.#request("/api/sentence/getSentence",(data)=>{
                callback(this.#genSentenceObject(data));
            });
        }
        else{
            callback(this.#RandomSentences(1));
        }
    }

    static updateSentenceError(id,errors,callback=()=>{}){
        if(!this.isOnline)return;
        this.#requestPost("/api/sentence/updateSentenceError",{idSentence:id,errors:errors},callback);
    }


    //#region record
    static addRecord(score,time,username,callback=()=>{}){
        this.#requestPost("/api/record/addRecord",{score:score,time:time,username:username},callback);
    }

    static getTopTen(callback){
        if(!this.isOnline){
            callback(null);
            return;
        }
        this.#request("/api/record/getRecordTopTen",callback);
    }

    //#endregion

    //#region Offline fonction

    static test(){
        console.log(this.#RandomSentences(5));
    }

    static #jsonToSentenceObject(data){
        let sentences=[];
        for (let index = 0; index < data.length; index++) {
            const sen = data[index];
            
            let errors=[];
            // get error
            for (let index = 0; index < sen.errors.length; index++) {
                const err = sen.errors[index];
                if(err.fkSentence==sen.idSentence){
                    errors.push(new SentenceError("",err.startCharPos,err.endCharPos));
                }
            }
            let newSen=new Sentence(index,sen.sentence,errors);
            sentences.push(newSen);
        }
        return sentences;
    }

    static SentenceObjectToJson(data,AddErrors){
        let sentenceData={
            sentence: data.sentence,
            errors: [
            ]
        };

        for (const element of AddErrors) {
            sentenceData.errors.push({
                endCharPos: element.endPos,
                startCharPos: element.startPos
            })
        }
        return sentenceData;
    }

    static #RandomSentences(number){
        if(GameAdmin.instance==null)return;

        let useIndex=GameAdmin.instance.indexUs;
        let d=dataOffLine.data;

        let sen=[];

        let y = 0;

        while(true){
            if(sen.length>=number || sen.length>=d.length-useIndex.length)break;
            let i = this.#getRandomInt(d.length);
            if(!useIndex.includes(i)){
                sen.push(d[i]);
                useIndex.push(i);
                y++
            }
        }
        return this.#jsonToSentenceObject(sen);
    }

    static #AllSentence(){
        return this.#jsonToSentenceObject(dataOffLine.data);
    }
    


    /**
     * Donne un nombre entier entre 0 et max
     * @param {int} max nombre max 
     * @returns nombre aléatoire
     */
    static #getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }

    //#endregion

}
